import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["container"]
  static values = { date: String }

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create("ScheduleChannel", {
      connected: () => {
        console.log("Connected to schedule channel")
      },
      disconnected: () => {
        console.log("Disconnected from schedule channel")
      },
      received: (data) => {
        this.handleUpdate(data)
      }
    })

    // Auto-scroll to current time on page load if it's today
    this.scrollToCurrentTimeIfToday()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  handleUpdate(data) {
    switch(data.type) {
      case "appointment_updated":
        this.refreshView()
        break
      case "appointment_created":
        this.refreshView()
        break
      case "appointment_deleted":
        this.refreshView()
        break
      default:
        console.log("Unknown update type:", data.type)
    }
  }

  refreshView() {
    // Refresh the current view using Turbo
    window.location.reload()
  }

  scrollToCurrentTimeIfToday() {
    // Check if the displayed date is today
    const scheduleDate = new Date(this.dateValue)
    const today = new Date()
    
    // Compare dates (ignoring time)
    const isToday = scheduleDate.toDateString() === today.toDateString()
    
    if (!isToday) {
      return // Don't scroll if it's not today
    }
    
    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    
    // Check if current time is within schedule range (8h-23h)
    if (currentHour < 8 || currentHour >= 23) {
      return // Don't scroll if current time is outside schedule range
    }
    
    // Format current time as HHMM to match the data-time attributes
    const currentTimeStr = currentHour.toString().padStart(2, '0') + 
                          (Math.floor(currentMinute / 5) * 5).toString().padStart(2, '0')
    
    // Use setTimeout to ensure the DOM is fully rendered
    setTimeout(() => {
      // Find the first time slot element that matches the current time
      const timeSlot = this.element.querySelector(`[data-time="${currentTimeStr}"]`)
      
      if (timeSlot) {
        // Get the position relative to the viewport
        const rect = timeSlot.getBoundingClientRect()
        const currentScrollY = window.pageYOffset || document.documentElement.scrollTop
        
        // Calculate the absolute position of the element
        const elementTop = rect.top + currentScrollY
        
        // Get the height of the fixed header to offset properly
        const header = this.element.querySelector('[data-agenda-header-target="header"]')
        const headerHeight = header ? header.offsetHeight : 128
        
        // Scroll to position the time slot just below the fixed header
        window.scrollTo({
          top: elementTop - headerHeight - 20, // 20px padding for better visibility
          behavior: 'smooth'
        })
      }
    }, 150)
  }
}
